module.exports = __webpack_public_path__ + "static/media/healthcare.cd01476d.png";